import React from "react";

export const Reports = () => {
  return <h1>Reports</h1>;
};
